import numbro from 'numbro';

export default function formatWinnings(
  winningsInCents: number,
  mantissa: number,
  average: boolean,
) {
  const winningsInDollars = winningsInCents / 100;
  const format: numbro.Format = {
    mantissa,
    trimMantissa: true,
    thousandSeparated: true,
    average,
    spaceSeparated: false,
  };

  if (winningsInDollars >= 1e3 && average) {
    let forceAvg: numbro.Format['forceAverage'];
    switch (true) {
      case winningsInDollars < 1e6:
        forceAvg = 'thousand';
        break;
      case winningsInDollars < 1e9:
        forceAvg = 'million';
        break;
      case winningsInDollars < 1e12:
        forceAvg = 'billion';
        break;
      default:
        forceAvg = 'trillion';
    }
    format.forceAverage = forceAvg;
  }
  return numbro(winningsInDollars).formatCurrency(format);
}
